"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForEvent = waitForEvent;
const withTimeout_1 = require("./withTimeout");
/**
 * Wait for an event to be emitted on emitter within timeout.
 *
 * @param emitter emitter of event
 * @param eventName event to wait for
 * @param timeout amount of time in milliseconds to wait for
 * @param predicate function that gets passed the event arguments, should return true if event accepted
 * @param abortSignal
 * @returns {Promise<unknown[]>} resolves with event arguments if event occurred within timeout else rejects
 */
async function waitForEvent(emitter, eventName, timeout = 5000, predicate = () => true, abortSignal) {
    let listener;
    const task = new Promise((resolve) => {
        listener = (...eventArgs) => {
            if (predicate(...eventArgs)) {
                resolve(eventArgs);
            }
        };
        emitter.on(eventName, listener);
    });
    return (0, withTimeout_1.withTimeout)(task, timeout, 'waitForEvent', abortSignal).finally(() => {
        emitter.off(eventName, listener);
    });
}
//# sourceMappingURL=waitForEvent.js.map